/* eslint-disable jsx-a11y/anchor-is-valid */
import { Col, Grid, Row } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import { compose, pure, withHandlers, withState } from "recompose";

import Button from "../../../elements/CustomButton/CustomButton";
import { CancelButton } from "../../../elements/ActionButtons/CancelButton";
import Card from "../../Card/Card";
import ExpenseFormTaxLine from "../../Expense/ExpenseForm/ExpenseFormTaxLine";
import { FIXED2 } from "../../../tools/fixedTools";
import NotificationProvider from "../../../elements/NotificationContent/Notifications";
import PaymentAffectationActionButton from "./PaymentAffectationActionButton";
import PaymentAffectationDataRecap from "./PaymentAffectationDataRecap";
import PaymentAffectationFields from "./PaymentAffectationFields";
import PaymentFormAttachment from "./PaymentFormAttachment";
import Queries from "../../../queries/queries2";
import React from "react";
import ReactSlidingPane from "react-sliding-pane";
import { SaveButton } from "../../../elements/ActionButtons/index";
import SuperpositionHeader from "../../Header/SuperpositionHeader";
import { TTC2HT } from "../../../tools/ttcConversion";
import UpdatedFailedNotificationContent from "../../../elements/NotificationContent/UpdateFailedNotification";
import _ from "lodash";
import { addPaymentTaxLineHandler } from "./hoc/addPaymentTaxLineHandler";
// import { computeTaxTotalHandler } from "./hoc/computeTaxTotalHandler";
import { prepareTaxLine } from "../../../hoc/taxes/prepareTaxLine";
import { viewPortDimension } from "../../../tools/viewportDimension";
import { graphql } from "react-apollo";
import Spinner from "../../../elements/Spinner/Spinner";


const formatTransactionLines = (transactionLines, bankTransaction, exchangeRate, companyDefaultInfos) => {

  // console.log("34 - exchangeRate=", exchangeRate);
  const lines = transactionLines.map(line => {
    const shouldDisplaytaxes =
      (companyDefaultInfos.company.isTaxActive) ||
      (line &&
        line.category.categoryFamily &&
        line.category.categoryFamily.reportRentability);

    //const shouldInvert = bankTransaction.sensTransaction === "DEBIT";
    const shouldInvert = bankTransaction.amount < 0;

    return {
      id: line.id,
      amount: shouldInvert ? -line.amount : line.amount,
      // companyCurrencyAmount: undefined,
      companyCurrencyAmount: shouldInvert
        ? -line.companyCurrencyAmount
        : line.companyCurrencyAmount,
      valueTax: line.valueTax,
      categoryId: line.category && line.category.id,
      categoryName: line.category && line.category.name,
      categoryIds: line.category && line.category.ids,
      category: line.category,
      numLine: line.numLine,
      tiersClientId: line.tiersClient && line.tiersClient.id,
      projectId: line.project && line.project.id,
      tiersId: line.tiers && line.tiers.id,
      bankTransactionId: bankTransaction.id,
      taxPieces: line.taxPieces,
      shouldDisplaytaxes: shouldDisplaytaxes,
      tiers: line.tiers,
      advancePayment: line.advancePayment
    };
  });
  return lines;
};

const displayPanel = withState("displayPanel", "setDisplayPanel", false);

const displayPanelTexts = withState(
  "displayPanelTexts",
  "setDisplayPanelTexts",
  {
    paneTitleIds: "ids_confirm",
    paneContentIds: "ids_confirmDeleteBankTransaction"
  }
);

const attachment = withState(
  "attachment",
  "setAttachment",
  ({ bankTransaction }) => {
    return bankTransaction && bankTransaction.attachment;
  }
);

const attachmentHandlers = withHandlers({
  onCreateAttachment: ({
    setAttachment,
    attachment,
    bankTransaction,
    companyId,
    createAttachmentMutation
  }) => async value => {
    console.log("createAttachment", attachment, bankTransaction, value);

    const newAttachment = {
      bucket: "netwips",
      companyId,
      key: value.fileKey,
      path: value.filename
    };

    // console.log("newAttachment", newAttachment);
    const attachmentCreated = await createAttachmentMutation({
      variables: { ...newAttachment }
    });

    console.log("attachmentCreated", attachmentCreated);
    setAttachment({ ...attachmentCreated.data.createAttachment });
  },
  onDeleteAttachment: ({
    deleteBankTransactionAttachmentMutation,
    bankTransaction,
    companyId,
    setAttachment,
    attachment
  }) => async value => {
    console.log(
      "onDeleteAttachment",
      value,
      bankTransaction,
      attachment,
      companyId
    );
    if (bankTransaction) {
      console.log("with refetch");
      const res = await deleteBankTransactionAttachmentMutation({
        variables: { id: attachment.id },
        refetchQueries: [
          {
            query: Queries.GET_BANK_TRANSACTION,
            variables: {
              id: bankTransaction.id
            }
          }
        ]
      });

      setAttachment(null);

      console.log("delete res", res);
    } else {
      console.log("no refetch");
      const res = await deleteBankTransactionAttachmentMutation({
        variables: { id: attachment.id }
      });
      console.log("delete res", res);
    }
  }
});

const dateState = withState(
  "dateState",
  "setDateState",
  ({ bankTransaction }) => {
    return bankTransaction.date;
  }
);

const fullUpdate = withState(
  "fullUpdate",
  "setFullUpdate",
  ({ }) => {
    return false;
  }
);

const lines = withState("lines", "setLines", ({ bankTransaction, exchangeRate, companyDefaultInfos }) => {
  // console.log(
  //   "bankTransaction.bankTransactionLines",
  //   bankTransaction.bankTransactionLines
  // );
  const lines =
    bankTransaction &&
    formatTransactionLines(
      bankTransaction.bankTransactionLines,
      bankTransaction,
      exchangeRate,
      companyDefaultInfos
    );
  return lines || [];
});

const lineHandlers = withHandlers({
  addLine: ({ setLines, lines, bankTransaction, exchangeRate, setFullUpdate }) => amount => {
    // console.log("175 - lineHandlers", lines, bankTransaction, amount, exchangeRate.getExchangeRate);

    const computedAmount =
      bankTransaction.amount < 0
        ? -bankTransaction.amount
        : bankTransaction.amount;

    const sumOfAllAmounts = _.map(lines, "amount").reduce((a, b) => a + b, 0);

    // fetch line[index-1].categoryId
    const categoryId =
      lines.length > 0 ? lines[lines.length - 1].categoryId : null;

    const categoryIds =
      lines.length > 0 ? lines[lines.length - 1].categoryIds : null;

    const shouldDisplaytaxes =
      lines.length > 0 ? lines[lines.length - 1].shouldDisplaytaxes : null;

    const rate = exchangeRate && exchangeRate.getExchangeRate && exchangeRate.getExchangeRate.value || 1;

    const newLine = {
      id: "",
      amount: FIXED2(computedAmount - sumOfAllAmounts), //lines.length === 0 ? computedAmount : 0,
      companyCurrencyAmount: FIXED2((computedAmount - sumOfAllAmounts) * rate),
      categoryId,
      categoryIds,
      numLine: lines.length,
      valueTax: 0,
      tiers: null,
      tiersClient: null,
      project: null,
      tiersId: "",
      bankTransactionId: bankTransaction.id,
      taxPieces: [],
      shouldDisplaytaxes,
      advancePayment: false
    };
    console.log("205 - newLine=", newLine);

    // console.log("223 - setFullUpdate(true);");
    setFullUpdate(true);
    setLines(lines => [...lines, newLine]);
  },
  updateLine: ({ lines, setLines, setFullUpdate }) => (lineIndex, line) => {
    // console.log("228 - setFullUpdate(true);");
    setFullUpdate(true);
    setLines([
      ...lines.slice(0, lineIndex),
      line,
      ...lines.splice(lineIndex + 1)
    ]);
  },
  removeLine: ({ setLines, lines, setFullUpdate }) => index => {
    // console.log("237 - setFullUpdate(true);");
    setFullUpdate(true);
    setLines(lines => [...lines.slice(0, index), ...lines.slice(index + 1)]);
  },
  removeTaxLine: ({ setLines, lines, setFullUpdate }) => (index, lineIndex) => {
    let currentLineTaxPieces = [...lines[lineIndex].taxPieces];
    currentLineTaxPieces.splice(index, 1);

    lines[lineIndex].taxPieces = currentLineTaxPieces;
    // console.log("246 - setFullUpdate(true);");
    setFullUpdate(true);
    setLines([...lines]); // TODO: check id not mutating is bad here
  },
  resetLines: ({ setLines, bankTransaction, setFullUpdate }) => () => {
    const lines =
      bankTransaction &&
      formatTransactionLines(
        bankTransaction.bankTransactionLines,
        bankTransaction
      );
    // console.log("257 - setFullUpdate(true);");
    setFullUpdate(true);
    setLines(lines || []);
  }
});

const amountHandlers = withHandlers({
  onAmountChange: ({ bankTransaction, addLine, lines }) => () => {
    const sumOfAllAmounts = _.map(lines, "amount").reduce((a, b) => a + b, 0);
    const bankTransactionAmount = Math.abs(bankTransaction.amount);
    if (
      (bankTransactionAmount > 0 && sumOfAllAmounts < bankTransactionAmount) ||
      (bankTransactionAmount < 0 && sumOfAllAmounts > bankTransactionAmount)
    ) {
      addLine(FIXED2(bankTransactionAmount - sumOfAllAmounts));
    }
  }
});

const lineValueHandlers = withHandlers({
  onLineValueChange: ({ setLines, onAmountChange, lines, exchangeRate, setFullUpdate }) => async (
    key,
    value,
    index
  ) => {
    // console.log("277 - key=", key, "value=", value, "index=", index, "lines=", lines);
    const oldValues = lines[index];
    // console.log("280 - oldValues=", oldValues);

    try {
      if ("categoryId" === key) {
        const shouldDisplaytaxes =
          value &&
          value.categoryFamily &&
          value.categoryFamily.reportRentability;

        if (oldValues && value && oldValues.categoryId !== value.id) {
          // console.log("294 - setFullUpdate(true);");
          setFullUpdate(true);
        }

        await setLines(lines => {
          let obj = {
            ...lines[index],
            categoryId: (value && value.id) || undefined,
            categoryName: (value && value.name) || "",
            categoryIds: (value && value.ids) || "",
            tiersId: undefined,
            shouldDisplaytaxes: shouldDisplaytaxes
          };
          // reset taxPieces if we shoulnt display taxes
          if (!shouldDisplaytaxes) obj.taxPieces = [];

          return [
            ...lines.slice(0, index),
            // update amount, update taxPieces
            obj,
            ...lines.slice(index + 1)
          ];
        });
      }

      if ("tiersId" === key) {

        if (oldValues && value && oldValues.tiersId !== value) {
          // console.log("322 - setFullUpdate(true);");
          setFullUpdate(true);
        }

        await setLines(lines => [
          ...lines.slice(0, index),
          { ...lines[index], tiersId: value, advancePayment: false, error: undefined },
          ...lines.slice(index + 1)
        ]);
      }

      if ("tiersClientId" === key) {

        if (oldValues && value && oldValues.tiersClientId !== value) {
          // console.log("336 - setFullUpdate(true);");
          setFullUpdate(true);
        }

        await setLines(lines => [
          ...lines.slice(0, index),
          { ...lines[index], tiersClientId: value, error: undefined },
          ...lines.slice(index + 1)
        ]);
      }

      if ("projectId" === key) {

        if (oldValues && value && oldValues.projectId !== value) {
          // console.log("350 - setFullUpdate(true);");
          setFullUpdate(true);
        }

        await setLines(lines => [
          ...lines.slice(0, index),
          { ...lines[index], projectId: value, error: undefined },
          ...lines.slice(index + 1)
        ]);
      }

      if ("taxPieces" === key) {
        let taxPiece = lines[index].taxPieces[value.index];
        // update the taxPiece
        taxPiece = value.value;
        let thisLine = lines[index];
        const ht = FIXED2(thisLine.amount - taxPiece.amount);
        const tax = FIXED2(thisLine.amount - ht);
        taxPiece.amount = tax;

        let taxPieces = lines[index].taxPieces;
        taxPieces[value.index] = taxPiece;

        // if (oldValues && value && oldValues.tiersClientId !== value)
        // console.log("374 - setFullUpdate(true);");
        setFullUpdate(true);

        await setLines(lines => [
          ...lines.slice(0, index),
          { ...lines[index], taxPieces },
          ...lines.slice(index + 1)
        ]);
      }

      if (key === "amount") {
        let newTaxPieces = lines[index].taxPieces;
        // recompute line taxes using new 'value' amount
        let thisLine = lines[index];
        const lineTTC = FIXED2(value);
        const taxPieces = thisLine.taxPieces.map((taxPiece, index) => {
          const ht = TTC2HT(value, taxPiece.taux);
          const tax = FIXED2(lineTTC - ht);
          return { ...thisLine.taxPieces[index], amount: tax };
        });
        newTaxPieces = [...taxPieces];
        // console.log("taxes", taxPieces);

        const rate = exchangeRate && exchangeRate.getExchangeRate && exchangeRate.getExchangeRate.value || 1;

        let companyCurrencyAmount = thisLine.companyCurrencyAmount;
        if (thisLine.amount !== value || thisLine.companyCurrencyAmount === undefined) {
          companyCurrencyAmount = FIXED2(value * rate);
        }

        // console.log("404 - setFullUpdate(true);");
        setFullUpdate(true);
        await setLines(lines => [
          ...lines.slice(0, index),
          // update amount, update taxPieces
          {
            ...lines[index],
            amount: FIXED2(value),
            companyCurrencyAmount: companyCurrencyAmount,
            taxPieces: newTaxPieces
          },
          ...lines.slice(index + 1)
        ]);
      }

      if (key === "companyCurrencyAmount") {

        // console.log("421 - setFullUpdate(true);");
        setFullUpdate(true);
        await setLines(lines => [
          ...lines.slice(0, index),
          {
            ...lines[index],
            companyCurrencyAmount: FIXED2(value)
          },
          ...lines.slice(index + 1)
        ]);
      }

      if (key === "amount" && index === lines.length - 1) {
        // notify last line has changed
        onAmountChange();
      }

      if (key === "advancePayment") {
        // console.log("439 - setFullUpdate(true);");
        setFullUpdate(true);
        await setLines(lines => [
          ...lines.slice(0, index),
          {
            ...lines[index],
            advancePayment: value
          },
          ...lines.slice(index + 1)
        ]);
      }
    } catch (e) {
      console.log("e", e);
    }
  }
});

const BackBtnText = ({ sensTransaction, children }) => {
  if (sensTransaction === "DEBIT") {
    return (
      <FormattedMessage id="ids_affectAnExpense">{children}</FormattedMessage>
    );
  }
  return (
    <FormattedMessage id="ids_affectAReceipt">{children}</FormattedMessage>
  );
};



const exchangeRate = graphql(Queries.getExchangeRate, {
  name: "exchangeRate",
  options: ({ bankTransaction, companyDefaultInfos }) => {
    return {
      fetchPolicy: "cache-and-network",
      variables: {
        date: bankTransaction.fixedDate,
        currencyId: bankTransaction.bankAccount &&
          bankTransaction.bankAccount.currency.id,
        companyCurrencyId: companyDefaultInfos.company.currency.id
      }
    };
  }
});


let PaymentAffectationForm = ({
  bankTransaction,
  updateBankTransaction,
  onLineValueChange,
  addLine,
  updateLine,
  addPaymentTaxLine,
  removeLine,
  removeTaxLine,
  resetLines,
  saveLines,
  deleteBankTransaction,
  reQualifyBankTransaction,
  companyId,
  companyDefaultInfos,
  sendNotification,
  lines,
  setLines,
  displayPanel,
  setDisplayPanel,
  displayPanelTexts,
  setDisplayPanelTexts,
  // computeTaxTotal,
  onCreateAttachment,
  onDeleteAttachment,
  attachment,
  intl,
  dateState,
  setDateState,
  fullUpdate,
  setFullUpdate,
  handleMinimizeSidebar,
  history,
  exchangeRate,
  addEventMutation
}) => {
  console.log("PaymentAffectationForm", lines);

  console.log("488 - fullUpdate=", fullUpdate);

  if (exchangeRate.getExchangeRate === undefined)
    return <Spinner size="lg" fullScreen />;

  if (lines.length === 0) {
    addLine(0);
  }

  let onPaneConfirm = async event => {
    //console.log("DeleteBT:", bankTransaction);

    await addEventMutation({
      variables: {
        companyId,
        invoiceId: null,
        quotationId: null,
        expenseId: null,
        bankTransactionId: bankTransaction.id,
        eventType: "EXPENSE_SUPPRIME"
      }
    });

    deleteBankTransaction(bankTransaction.id);
    setDisplayPanel(false);
  };

  async function manageDeleteBankTransaction(values) {
    console.log("(local) deleteBankTransaction", values);

    //console.log("local=", locale);
    // console.log("intl=", intl);
    // console.log("displayPanel=", displayPanel);

    // console.log("DeleteBT ?", bankTransaction);
    let displayConfirm = false;
    for (const ecritureLine of bankTransaction.ecritureLines) {
      if (ecritureLine.labelLettrage !== "" && !displayConfirm)
        displayConfirm = true;
    }

    const lettreArray = new Array();
    if (bankTransaction.ecritureLines.length > 0) {

      for (const ecritureLine of bankTransaction.ecritureLines) {
        if (ecritureLine.labelLettrage !== "" && ecritureLine.tiers) {

          const nonLettre = {
            tiersId: ecritureLine.tiers.id,
            amount: ecritureLine.amount,
            alreadyDone: false
          };
          lettreArray.push(nonLettre);
        }
      }

      if (lettreArray.length > 0) {
        setDisplayPanel(true);
        setDisplayPanelTexts({
          paneTitleIds: "ids_confirm",
          paneContentIds: "ids_confirmDeleteBankTransaction"
        });
      }
      else {

        // console.log("deleteBankTransaction", values);
        await addEventMutation({
          variables: {
            companyId,
            invoiceId: null,
            quotationId: null,
            expenseId: null,
            bankTransactionId: bankTransaction.id,
            eventType: "EXPENSE_SUPPRIME"
          }
        });

        deleteBankTransaction(values);
        setDisplayPanel(false);
      }
    } else {

      // console.log("deleteBankTransaction", values);
      await addEventMutation({
        variables: {
          companyId,
          invoiceId: null,
          quotationId: null,
          expenseId: null,
          bankTransactionId: bankTransaction.id,
          eventType: "EXPENSE_SUPPRIME"
        }
      });

      deleteBankTransaction(values);
      setDisplayPanel(false);
    }
  }

  async function manageReQualifyBankTransaction(values) {
    console.log("(local) reQualifyBankTransaction", values);

    reQualifyBankTransaction(values);
    //setDisplayPanel(false);
  }

  const editMode = true;

  const dimension = viewPortDimension();
  console.log("viewPortDimension", dimension);

  const slidingPaneWidth =
    Math.min(dimension.width - 200, 600).toString() + "px";

  console.log(displayPanelTexts.paneTitleIds);

  let title = intl.formatMessage({ id: displayPanelTexts.paneTitleIds });
  console.log("title", title);

  let content = intl.formatMessage({ id: displayPanelTexts.paneContentIds });
  console.log("content", content);


  const nonLettreArray = new Array();
  for (const ecritureLine of bankTransaction.ecritureLines) {
    if (ecritureLine.labelLettrage === "" && ecritureLine.tiers) {
      const nonLettre = {
        tiersId: ecritureLine.tiers.id,
        amount: ecritureLine.amount,
        alreadyDone: false
      };
      nonLettreArray.push(nonLettre);
    }
  }

  // console.log("601 - nonLettreArray=", nonLettreArray);
  // console.log("659 - exchangeRate=", exchangeRate);
  // console.log("660 - line=", line);
  // console.log("663 - bankTransaction=", bankTransaction);


  return (
    <div>
      <BackBtnText
        sensTransaction={bankTransaction.amount < 0 ? "DEBIT" : "CREDIT"}
      >
        {backBtnText => (
          <SuperpositionHeader
            backBtnText={backBtnText}
            handleMinimizeSidebar={handleMinimizeSidebar}
          >
            {true && (
              <ReactSlidingPane
                isOpen={displayPanel}
                title={title}
                width={slidingPaneWidth}
                onRequestClose={() => setDisplayPanel(false)}
              >
                {true && (
                  <div>
                    <p>{content}</p>
                    {true && (
                      <CancelButton onClick={() => setDisplayPanel(false)} />
                    )}
                    {true && (
                      <Button
                        icon
                        fill
                        bsStyle="primary"
                        onClick={event => onPaneConfirm(event)}
                      >
                        <i className="fa fa-lg fa-check" />
                        <FormattedMessage id="ids_confirm" />
                      </Button>
                    )}
                  </div>
                )}
              </ReactSlidingPane>
            )}

            <div className="space-between">
              {
                <PaymentAffectationActionButton
                  payment={bankTransaction}
                  deletePayment={manageDeleteBankTransaction}
                  reQualifyPayment={manageReQualifyBankTransaction}
                />
              }
              {/* <CancelButton onClick={resetLines} /> */}
              <SaveButton
                fill
                onClick={() => {
                  // console.log("confirm lines", lines);
                  saveLines(lines, attachment, dateState, fullUpdate)
                    // .then()
                    .catch(err => {
                      // console.log("ERR=", JSON.stringify(err, null, 2));

                      const notif = NotificationProvider.getFailureNotification();
                      if (err.amount && err.amount !== 0) {
                        notif.message = (
                          <div>
                            <FormattedMessage id="ids_updateFailedEcart" />{" "}
                            {FIXED2(err.amount)}
                          </div>
                        );
                      } else {
                        notif.message = (
                          <FormattedMessage id="ids_updateFailed" />
                        );
                      }

                      sendNotification(notif);
                      err.errorLines &&
                        err.errorLines.forEach(l => {
                          let lError = lines[l];
                          if (lError) {
                            lError.error = true;
                            setLines([
                              ...lines.slice(0, l),
                              lError,
                              ...lines.splice(l + 1)
                            ]);
                          }
                        });
                    });
                }}
              />
            </div>
          </SuperpositionHeader>
        )}
      </BackBtnText>
      <div className="main-content">
        <Grid fluid>
          <Card>
            <Row>
              <Col xs={12}>
                <div
                  className="content"
                // style={{ padding: "1px 15px 1px 15px" }}
                >
                  <Row>
                    <PaymentAffectationDataRecap
                      payment={bankTransaction}
                      dateState={dateState}
                      setDateState={setDateState}
                    />
                  </Row>
                </div>
                <hr />
                {lines &&
                  lines.map((line, lineIndex) => {
                    // console.log("769 - bankTransaction=", bankTransaction, line, nonLettreArray);
                    // console.log("*********************************************");

                    let found = -1;
                    if (nonLettreArray.length === 0) {
                      if (
                        line.categoryIds === "ids_clients" ||
                        line.categoryIds === "ids_suppliers" ||
                        line.categoryIds === "ids_collaborators"
                      ) {
                        found = -1;
                      }
                      else if (
                        line.id === "" ||
                        line.categoryIds === null
                      ) {
                        found = 0;
                      }
                    }
                    else {
                      found = nonLettreArray.findIndex((element) => {
                        let factorX = -1;
                        if (bankTransaction.amount < 0)
                          factorX = 1;

                        // console.log("element=", element);
                        // console.log("line=", line, lineIndex);
                        // console.log("1 =", element.alreadyDone);
                        // console.log("2 =", element.tiersId === line.tiersId);
                        // console.log("3 = ", FIXED2(element.amount), FIXED2(line.amount * factorX));

                        if (bankTransaction.ecritureLines && bankTransaction.ecritureLines.length <= lineIndex + 1)
                          return false;

                        const ecritureLineAmount = bankTransaction.ecritureLines[lineIndex + 1].amount;
                        const ecritureLineAmount2 = bankTransaction.ecritureLines[lineIndex].amount;
                        // console.log("594 - ecritureLineAmount=", ecritureLineAmount);
                        // console.log("594 - ecritureLineAmount2=", ecritureLineAmount2);

                        // return (!!!element.alreadyDone && element.tiersId === line.tiersId && FIXED2(element.amount) === FIXED2(line.amount * factorX));
                        // console.log("!!!element.alreadyDone =", !!!element.alreadyDone);
                        // console.log("element.tiersId === line.tiersId =", element.tiersId === line.tiersId);
                        // console.log("FIXED2(element.amount) === FIXED2(ecritureLineAmount) =", FIXED2(element.amount) === FIXED2(ecritureLineAmount));
                        // console.log("FIXED2(element.amount) === FIXED2(ecritureLineAmount2) =", FIXED2(element.amount) === FIXED2(ecritureLineAmount2));

                        return (!!!element.alreadyDone && element.tiersId === line.tiersId && (
                          FIXED2(element.amount) === FIXED2(ecritureLineAmount) ||
                          FIXED2(element.amount) === FIXED2(ecritureLineAmount2)
                        ));
                      });
                      // console.log("*********************************************");

                      if (found > -1) {
                        // console.log("FOUND - ", found);
                        nonLettreArray[found].alreadyDone = true;
                      }
                      // console.log("586 - ", nonLettreArray, found);

                      if (line.companyCurrencyAmount === undefined || isNaN(line.companyCurrencyAmount)) {
                        const rate = (exchangeRate.getExchangeRate && exchangeRate.getExchangeRate.value) || 1;
                        line.companyCurrencyAmount = line.amount * rate;
                      }
                    }

                    return (
                      <div
                        className="content"
                        style={{ padding: "1px 15px 1px 15px" }}
                        key={lineIndex}
                      >
                        <Row>
                          <PaymentAffectationFields
                            nonLettre={found > -1}
                            line={line}
                            error={line.error}
                            key={lineIndex}
                            index={lineIndex}
                            removeLine={removeLine}
                            companyDefaultInfos={companyDefaultInfos}
                            //sensTransaction={bankTransaction.sensTransaction}
                            sensTransaction={
                              bankTransaction.amount < 0 ? "DEBIT" : "CREDIT"
                            }
                            onLineValueChange={(key, value) =>
                              onLineValueChange(key, value, lineIndex)
                            }
                            onCategoryChange={cat => {
                              console.log(
                                "PaymentAffectationFields.onCategoryChange",
                                cat
                              );
                            }}
                            currencyId={
                              bankTransaction.bankAccount &&
                              bankTransaction.bankAccount.currency.id
                            }
                            companyId={companyId}
                            sendNotification={sendNotification}
                            date={bankTransaction.fixedDate}
                            companyCurrencyId={
                              companyDefaultInfos.company.currency.id
                            }
                            history={history}
                            currency={bankTransaction.bankAccount &&
                              bankTransaction.bankAccount.currency}
                            getExchangeRate={exchangeRate.getExchangeRate}
                          />
                        </Row>
                        <Row>
                          {line &&
                            line.shouldDisplaytaxes &&
                            line.taxPieces &&
                            line.taxPieces.map((taxPiece, taxPieceIndex) => (
                              <ExpenseFormTaxLine
                                key={taxPieceIndex}
                                index={taxPieceIndex}
                                lineIndex={lineIndex}
                                totalTTC={bankTransaction.amount}
                                removeTaxLine={removeTaxLine}
                                taxPiece={taxPiece}
                                onChange={(taxPiece, index, lineIndex) => {
                                  // console.log("updateFormValue", taxPiece);
                                  onLineValueChange(
                                    "taxPieces",
                                    { value: taxPiece, index },
                                    lineIndex
                                  );
                                  // return updateFormValue("taxPieces", [
                                  //   ...formValues.taxPieces.slice(0, index),
                                  //   taxPiece,
                                  //   ...formValues.taxPieces.slice(index + 1)
                                  // ]);
                                }}
                                companyId={companyId}
                                editMode={editMode}
                                currencyId={
                                  bankTransaction.bankAccount.currency.id
                                }
                              >
                                {/* {console.log("DATA taxPiece", taxPiece)} */}
                              </ExpenseFormTaxLine>
                            ))}
                        </Row>
                        {line && line.shouldDisplaytaxes && (
                          <div className="text-right">
                            <a
                              onClick={() => {
                                if (editMode) {
                                  addPaymentTaxLine({
                                    prepareTaxLine,
                                    line,
                                    lineIndex,
                                    amount: bankTransaction.amount,
                                    updateLine,
                                    companyDefaultInfos
                                    // computeTaxTotal
                                  });
                                }
                              }}
                            >
                              <i className="fa fa-plus" />
                              {intl.formatMessage({ id: "ids_addATax" })}
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  })}
                <div className="text-right">
                  <hr />
                  <a onClick={() => addLine(0)}>
                    <i className="fa fa-plus" />
                    {intl.formatMessage({ id: "ids_addALine" })}
                  </a>
                </div>
              </Col>
            </Row>
            <Row>
              <div className="content">
                <PaymentFormAttachment
                  file={attachment}
                  createAttachment={attachment => {
                    // setFormValues({ ...formValues, attachment });
                    // invokes this.onCreateAttachment
                    onCreateAttachment(attachment);
                  }}
                  deleteAttachment={attachment =>
                    onDeleteAttachment(attachment)
                  }
                  companyId={companyId}
                  sendNotification={sendNotification}
                />
              </div>
              {/* <Col sm={6}>
              <PaymentFormAttachment
                updateFormValue={updateFormValue}
                file={file}
                createExpenseAttachment={attachment => {
                  // setFormValues({ ...formValues, attachment });
                  // invokes this.onCreateAttachment
                  onCreateAttachment(attachment);
                }}
                companyId={companyId}
                deleteExpenseAttachment={deleteExpenseAttachment}
              />
            </Col> */}
            </Row>
          </Card>
        </Grid>
      </div>
    </div>
  );
};

export default compose(
  exchangeRate,
  displayPanel,
  displayPanelTexts,
  lines,
  dateState,
  fullUpdate,
  attachment,
  lineHandlers,
  attachmentHandlers,
  prepareTaxLine,
  // computeTaxTotalHandler,
  addPaymentTaxLineHandler,
  amountHandlers,
  lineValueHandlers,
  injectIntl,
  pure
)(PaymentAffectationForm);
